module.exports = __webpack_public_path__ + "static/media/15_r_dom_79.79_33.61.8b9b03b2.png";